import { getJwt } from "@app/helpers";
import api from "../api";
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

const controller = '/NaoPrevistoAnexoSolicitacao';



export const getAnexoSolicitacao = async (id: string) => {
    return await api.get<any[]>(`${controller}/listar/${id}`);
}

export const deleteAnexoSolicitacao = async (id: string) => {
    return await api.delete(`${controller}/${id}`);
}

export const DownloadAnexoSolicitacao = (id: string, filename: string) => {
    let urlBase = window.location.origin;
    trackPromise(
      Axios.get(urlBase + `/api${controller}/downloadById/${id}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
      },
      })
        .then(resp => {
          if (filename !== '') {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.setAttribute('id', 'downloadArquivo');
            document.body.appendChild(link);
            link.click();
            document.getElementById('downloadArquivo').outerHTML = '';
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 404) {
              notification.error('Anexo não encontrado.');
            }
          }
        }),
    );
  };